import React, {useState} from "react";
import { data } from "../data/data";
import { InlineMath } from "react-katex";
import "../1/Part1.css"
const Part2 = () => {
	const { title, wordmateri1, wordmateri2, wordmateri3 } = data[1];
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	return (
		<div>
			<div className="container">
			<div className="d-flex justify-content-end">
			<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
			<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
			</div>
				<div
					style={{
						marginTop: "1.5rem",
						color: "#2d8659",
					}}
				>
					<h5 style={{fontSize:`${ukuranH}px`}}>{title}</h5>
				</div>
				<div
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize:`${ukuranP}px`
					}}
					className="col-sm-12 mt-3"
				>
					{wordmateri1}
				</div>
				<div
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize:`${ukuranP}px`
					}}
					className="col-sm-12 mt-3"
				>
					{wordmateri2}
				</div>
				<div
					style={{
						textIndent: "2rem",
						width: "100%",
						textAlign: "justify",
						lineHeight: "35px",
						fontSize:`${ukuranP}px`
					}}
					className="col-sm-12 mt-3"
				>
					{wordmateri3}
				</div>

				<div  className="text-center">
					<p style={{fontSize:`${ukuranP}px`}} className="blockquote">
						Bentuk umum model program linear sebagai berikut :
					</p>
					<p style={{fontSize:`${ukuranP}px`}} className="blockquote">Optimumkan</p>
					<p style={{ position: "relative", fontSize:`${ukuranP}px` }}>
						<InlineMath math="Z = \displaystyle\sum_{j=1}^n \small C \footnotesize j \small X \footnotesize j " />
					</p>

					<p style={{fontSize:`${ukuranP}px`}} className="blockquote">Dengan batasan: </p>
				</div>
				<div style={{ width: "80%", fontSize:`${ukuranP}px` }} className="row">
					<div className="col-md-6 offset-md-4    ">
						<p>
							<InlineMath math="Z = \displaystyle\sum_{j=1}^n  \footnotesize aij \text{ } \footnotesize xj ≥ bi " />
						</p>
					</div>
					<div className="col-md-2 ">
						<p>
							<InlineMath math="\text{untuk } i = 1,2,3,… ,m " />
						</p>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}}  className="text-center">
					<p>Atau</p>
				</div>
				<div style={{ width: "80%", fontSize:`${ukuranP}px` }} className="row">
					<div className="col-md-6 offset-md-4 ">
						<p style={{fontSize:`${ukuranP}px`}}>
							<InlineMath math="Z = \displaystyle\sum_{j=1}^n  \footnotesize aij \text{ } \footnotesize xj ≤ bi " />
						</p>
					</div>
					<div className="col-md-2">
						<p>
							<InlineMath math="\text{untuk } i = 1,2,3,… ,m " />
						</p>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="text-center">
					<p style={{ position: "relative" }}>
						<InlineMath math="xj ≥ 0, \text{ untuk } j = 1, 2, 3,..,n" />
					</p>
				</div>
				<div  className="text-center">
					<p style={{fontSize:`${ukuranP}px`}} className="blockquote">
						Atau dapat ditulis secara lengkap sebagai berikut:
					</p>
					<p style={{fontSize:`${ukuranP}px`}} className="blockquote"> Optimumkan</p>
					<p style={{fontSize:`${ukuranP}px`}}>
						<InlineMath math="Z = \footnotesize C \tiny 1 \footnotesize X \tiny 1 + \footnotesize C \tiny 2 \footnotesize X \tiny 2 + .... + \footnotesize C \tiny n \footnotesize X \tiny n  " />{" "}
					</p>
					<p style={{fontSize:`${ukuranP}px`}} className="blockquote">dengan batasan: </p>
				</div>
				<div className="row mb-2">
					<div className="col-sm-4 offset-lg-2">
						<div style={{ position: "relative", fontSize:`${ukuranP}px` }}>
							<InlineMath math="\small{a} \footnotesize{11} \small{x} \footnotesize{1} + \small{a} \footnotesize{11} \small{x} \footnotesize{1} + .... + \small{a} \footnotesize{1n} \small{x} \footnotesize{n} \text{ } ≥  \small{b} \footnotesize{1}" />{" "}
						</div>
					</div>
					<div className="col-sm-2">
						<p style={{fontSize:`${ukuranP}px`}} >Atau</p>
					</div>
					<div className="col-sm-2">
						<div style={{ position: "relative" }}>
							<InlineMath math="\small{a} \footnotesize{11} \small{x} \footnotesize{1} + \small{a} \footnotesize{11} \small{x} \footnotesize{1} + .... + \small{a} \footnotesize{1n} \small{x} \footnotesize{n} \text{ }  ≤   \small{b} \footnotesize{1}" />
						</div>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="row">
					<div className="col-sm-4 offset-lg-2 mt-2">
						<div style={{ position: "relative" }}>
							<InlineMath math="\small{a} \footnotesize{21} \small{x} \footnotesize{1} + \small{a} \footnotesize{22} \small{x} \footnotesize{2} + .... + \small{a} \footnotesize{2n} \small{x} \footnotesize{n} \text{ } ≥  \small{b} \footnotesize{1}" />{" "}
						</div>
					</div>
					<div className="col-sm-2">
						<p style={{fontSize:`${ukuranP}px`}} >Atau</p>
					</div>
					<div className="col-sm-2">
						<div style={{ position: "relative", fontSize:`${ukuranP}px` }}>
							<InlineMath math="\small{a} \footnotesize{21} \small{x} \footnotesize{1} + \small{a} \footnotesize{22} \small{x} \footnotesize{2} +  .... + \small{a} \footnotesize{2n} \small{x} \footnotesize{n} \text{ }  ≤   \small{b} \footnotesize{1}" />
						</div>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="d-flex justify-content-center">
					<div
						style={{
							display: "flex",
							justifyContent: "space-between",
							width: "60%",
							alignContent: "center",
						}}
					>
						<p>.....</p>
						<p>.....</p>
						<p>.....</p>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="row">
					<div className="col-sm-4 offset-lg-2 mt-3">
						<div style={{ position: "relative" }}>
							<InlineMath math="\small{a} \footnotesize{m1} \small{x} \footnotesize{1} + \small{a} \footnotesize{m2} \small{x} \footnotesize{1} + .... + \small{a} \footnotesize{mn} \small{x} \footnotesize{n}  ≥  \small{b} \footnotesize{m}" />{" "}
						</div>
					</div>
					<div className="col-sm-2">
						<p>Atau</p>
					</div>
					<div className="col-sm-2">
						<div style={{ position: "relative" }}>
							<InlineMath math="\small{a} \footnotesize{m1} \small{x} \footnotesize{1} + \small{a} \footnotesize{m2} \small{x} \footnotesize{1} +  .... + \small{a} \footnotesize{mn} \small{x} \footnotesize{n}   ≤   \small{b} \footnotesize{m}" />
						</div>
					</div>
				</div>
				<div style={{fontSize:`${ukuranP}px`}} className="d-flex justify-content-center mt-4">
					<div style={{ position: "relative" }}>
						<InlineMath math="\small{x} \footnotesize{1},\small{x} \footnotesize{2},\small{x} \footnotesize{3},...,\small{x} \footnotesize{n} ≥ 0 " />
					</div>
				</div>
				<div className="mt-2">
					<p
						style={{
							lineHeight: "35px",
							textIndent: "2rem",
							width: "100%",
							textAlign: "justify",
							fontSize:`${ukuranP}px`
						}}
					>
						Simbol <i>x1, x2, x3, ..., xn (xi)</i> menunjukkan variabel penentu.
						Banyaknya variabel penentu <i>(xi)</i> oleh karenanya tergantung
						dari jumlah kegiatan atau aktivitas yang dilakukan untuk mencapai
						tujuan. Simbol <i>c1, c2,…, cn</i> merupakan kontribusi
						masing-masing peubah keputusan terhadap tujuan, disebut juga
						koefisien fungsi tujuan pada model matematikanya. Simbol{" "}
						<i>a11, a1n, …. , amn</i> merupakan penggunaan per unit peubah
						keputusan akan sumber daya yang membatasi, atau disebut juga sebagai
						koefisien fungsi kendala pada model matematikanya. Simbol{" "}
						<i>b1, b2, … bm </i> menunjukkan jumlah masing-masing sumber daya
						yang ada. Jumlah fungsi kendala itu, akan tergantung dari banyaknya
						sumber daya yang terbatas.
					</p>

				</div>
                <div className="mt-2">
                    <p
                    style={{
                        lineHeight: "35px",
                        textIndent: "2rem",
                        width: "100%",
                        textAlign: "justify",
						fontSize:`${ukuranP}px`
                    }} 
                    >Pertidaksamaan terakhir <i>(x1, x2, x3, ... , xn ≥ 0)</i> menunjukkan batasan non negatif. Membuat model matematika dari suatu permasalahan bukan hanya menuntut kemampuan matematika, tapi juga menuntut seni permodelan. Menggunakan seni untuk membuat permodelan lebih mudah dan menarik.</p>
                </div>
			</div>
		</div>
	);
};

export default Part2;
